module.exports = __webpack_public_path__ + "static/media/Stellar King Bed Base - 180x210 cm.913ba3db.jpg";